import { Descriptions } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { isEnableToColumn } from '../../../../../../utils/isEnableToColumn';

export const CompanyInformation = ({ companyData }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!companyData) return;
  }, [companyData]);

  return (
    <Descriptions title={companyData.name} column={2}>
      <Descriptions.Item label={t('myCompanies.address')}>{companyData.address}</Descriptions.Item>
      <Descriptions.Item label={t('myCompanies.tax_id')}>{companyData.tax_id}</Descriptions.Item>
      <Descriptions.Item label={t('myCompanies.floor_name')}>{companyData.floor_name}</Descriptions.Item>
      <Descriptions.Item label={t('myCompanies.files_analyzed')}>{companyData.files_analyzed}</Descriptions.Item>
      <Descriptions.Item label={t('myCompanies.city')}>{companyData.city}</Descriptions.Item>
      <Descriptions.Item label={t('myCompanies.is_enabled')}>{isEnableToColumn(companyData.is_enabled)}</Descriptions.Item>
      <Descriptions.Item span={2} label={t('myCompanies.postal_code')}>
        {companyData.postal_code}
      </Descriptions.Item>
      <Descriptions.Item span={2} label={t('myCompanies.country')}>
        {companyData.country}
      </Descriptions.Item>
    </Descriptions>
  );
};
